import NotFound from './NotFound';
import { withRouter } from 'react-router-dom';
export default withRouter(NotFound);



// WEBPACK FOOTER //
// ./src/components/atomic/pages/NotFound/index.js